module.exports = __webpack_public_path__ + "img/zhong_ztb.fd8a5761.png";